import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();




  // アンカーリンク
  gsap.registerPlugin(ScrollToPlugin);

  function scrollToAnchor(e) {
    e.preventDefault();

    const offsetVH = window.innerHeight * 0.23; // その時点の10vh
    const targetId = this.getAttribute('href').slice(1);
    const targetElement = document.getElementById(targetId);
    if (!targetElement) return;

    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offsetVH;

    gsap.to(window, {
      duration: 1,
      scrollTo: targetPosition,
      ease: "power2.out"
    });
  }

  // アンカーリンククリックに対応
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', scrollToAnchor);
  });

  // ページロード時にURLハッシュがある場合にスクロール
  window.addEventListener('load', () => {
    if (location.hash) {
      const targetElement = document.getElementById(location.hash.slice(1));
      if (!targetElement) return;

      const offsetVH = window.innerHeight * 0.23;
      const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offsetVH;

      gsap.to(window, {
        duration: 0, // 即座にスクロール
        scrollTo: targetPosition
      });
    }
  });

  // リサイズ時にスクロール位置を調整（現在のハッシュがある場合）
  window.addEventListener('resize', () => {
    if (location.hash) {
      const targetElement = document.getElementById(location.hash.slice(1));
      if (!targetElement) return;

      const offsetVH = window.innerHeight * 0.23;
      const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offsetVH;

      gsap.to(window, {
        duration: 0,
        scrollTo: targetPosition
      });
    }
  });




  // CF7の遷移位置調整
  document.addEventListener('tccf7:scrollTo', e => {
    const header = document.querySelector('.anchor-header');
    const headerHeight = header ? header.offsetHeight : 0;

      const screenWidth = window.innerWidth;
      let offset = headerHeight + 100; // デフォルト
      if (screenWidth <= 1024) {
        offset = headerHeight * 0.3; // 1024px以下なら短く
      }

    gsap.to(window, {
      duration: 1,
      scrollTo: {
        y: "#" + e.detail.id,
        offsetY: offset
      },
      ease: "power2.inOut"
    });
  });



  if (document.body.classList.contains('contact') ) {
    topValidation();
  }


  var rellax = new Rellax('.rellax', {
  });


  const scrollHint = document.querySelector('.js-scroll')
  if(scrollHint){
    new ScrollHint(scrollHint, {
      i18n: {
        scrollable: "横スクロール",
      },
    });
  }


  // Lenis 初期化
  const lenis = new Lenis();
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);




  const menuBtn = document.querySelector('.menu-btn');
  const head = document.querySelector('header');

  menuBtn.addEventListener('click', () => {
    menuBtn.classList.toggle('is-open');
    head.classList.toggle('is-open');
  });


  const mvSwiper = new Swiper(".mv-slider", {
    loop: true,
    speed: 1500,
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: false,
    },
  });


  const thumbSwiper = new Swiper(".thumb-swiper", {
    slidesPerView: 4,
    spaceBetween: 10,
    watchSlidesProgress: true,
  });

  const mainSwiper = new Swiper(".main-swiper", {
    spaceBetween: 10,
    loop: true,
    thumbs: {
      swiper: thumbSwiper,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const leftSwiper = new Swiper(".left-swiper", {
    direction: 'vertical',
    loop: true,
    slidesPerView: 4,
    speed: 10000,
    allowTouchMove: false,
    spaceBetween: 15,
    autoplay: {
      delay: 0,
    },
    breakpoints: {
      799: {
        slidesPerView: 2,
        spaceBetween: 25,
      }
    },
  });

  const centerSwiper = new Swiper(".center-swiper", {
    direction: 'vertical',
    loop: true,
    slidesPerView: 4,
    speed: 10000,
    allowTouchMove: false,
    spaceBetween: 15,
    autoplay: {
      delay: 0,
      reverseDirection: true
    },
    breakpoints: {
      799: {
        slidesPerView: 2,
        spaceBetween: 25,
      }
    },
  });

  const rightSwiper = new Swiper(".right-swiper", {
    direction: 'vertical',
    loop: true,
    slidesPerView: 4,
    speed: 10000,
    allowTouchMove: false,
    spaceBetween: 15,
    autoplay: {
      delay: 0,
    },
    breakpoints: {
      799: {
        slidesPerView: 2,
        spaceBetween: 25,
      }
    },
  });



  const gridBg = document.querySelector('.grid-bg');
  const container = document.querySelector('.grid-bg-area');

  if(gridBg){

    function updateBgPosition() {
      const containerRect = container.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      if (containerRect.top <= 0 && containerRect.bottom >= viewportHeight) {
        // 画面内に収まっているときは固定
        gridBg.style.position = 'fixed';
        gridBg.style.top = '0';
      } else if (containerRect.top > 0) {
        // スクロール開始前
        gridBg.style.position = 'absolute';
        gridBg.style.top = '0';
      }
    }

    // スクロール時
    window.addEventListener('scroll', updateBgPosition);

    // リロード直後にも発火
    window.addEventListener('load', updateBgPosition);
  }




  const closeBtn = document.querySelector('.close');
  const bnr = document.querySelector('.recruit-bnr');
  const footer = document.querySelector('.cta');

  if(bnr){
    closeBtn.addEventListener('click', () => {
      closeBtn.classList.add('is-close');
      bnr.classList.add('is-close');
    });

    function scrollShow(){
      const footTop = footer.offsetTop;
      if(window.scrollY + window.innerHeight > footTop){
        bnr.classList.add('is-hide');
      } else if(window.matchMedia('(max-width: 796px)').matches && window.scrollY < window.innerHeight * 0.4){
        bnr.classList.add('is-hide');
      }else{
        bnr.classList.remove('is-hide')
      }
    }
    window.addEventListener('load',scrollShow);
    window.addEventListener('scroll',scrollShow);
    window.addEventListener('resize',scrollShow);
  }



  function fadeInAnimation() {
    const fadeInItems = document.querySelectorAll('.fade-in');
    fadeInItems.forEach((fadeIn) => {
      const triggerPoint = window.innerHeight * 0.7; // ビューポート高さの70%で発火
      const elementTop = fadeIn.getBoundingClientRect().top;
      if (elementTop < triggerPoint) {
        fadeIn.classList.add('is-animated');
      } else if (elementTop > triggerPoint && fadeIn.classList.contains('is-animated')) {
        fadeIn.classList.remove('is-animated');
      }
    });
  }

  window.addEventListener('scroll', fadeInAnimation);
  window.addEventListener('load', fadeInAnimation);


  window.addEventListener('load', function() {
  const elements = document.querySelectorAll('.load_fade-in');
  elements.forEach(el => el.classList.add('is-animated'));
});



});

